<template>
  <ibox>
    <template slot="title">お問合わせ一覧</template>
    <template slot="body">
      <div class="row">
        <div class=" col-sm-3 form-horizontal">
          <contact-search
              @click="contactSearch"></contact-search>
        </div>
        <div class=" col-sm-9">
          <table class="table table-hover">
            <thead>
            <tr>
              <th>ID</th>
              <th>問合せ日時</th>
              <th>氏名</th>
              <th>メールアドレス</th>
              <th></th>
              <th>
              </th>
            </tr>
            </thead>
            <tbody>
            <template v-for="contact in contacts">
              <contact-list-row :contact="contact"></contact-list-row>
            </template>
            </tbody>
          </table>
          <pager @click="clickPager" v-bind:pager="pager"></pager>
        </div>
      </div>
    </template>
  </ibox>

</template>

<script>
  import Api from '../../service/Api.vue'

  export default {
    created: function () {
      var contactId = this.$route.query.contact_id || ''
      this.contactSearch({
        contact_id: contactId
      })
    },
    data () {
      return {
        params: [],
        contacts: [],
        pager: false
      }
    },
    methods: {
      clickPager: function (page) {
        this.params.page = page
        this.contactSearch(this.params)
      },
      contactSearch: function (data) {
        data.order = 'updated_at'
        data.sort = 'DESC'
        this.params = data
        Api.contact.search(data).then(this.searchSuccess)
      },
      searchSuccess: function (response) {
        this.contacts = response.data.contacts
        this.pager = response.data.pager
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?626de20f